// Staging build environment. Substituted for environment.ts by the `staging`
// configuration's fileReplacements in angular.json.
// See docs/staging-backend-plan.md §5.1.
//
// Deliberately NOT a copy of environment.prod.ts. Staging stays in Angular dev
// mode so its extra change-detection assertions (notably
// ExpressionChangedAfterItHasBeenCheckedError) keep firing — a production build
// does not fix those bugs, it just stops reporting them, and staging is where
// we want them reported.

export const environment = {
    production: false,

    // Off by default: staging is redeployed constantly and service-worker
    // caching has testers chasing stale bundles. Flip to true to rehearse a
    // deploy's cache / update behavior, which is otherwise only observable in
    // production.
    serviceWorker: false,

    // Shown in the header and as the page title. Staging's says so, so a
    // staging tab is never mistaken for production.
    appTitle: 'April Sea Domains (staging)'
};
